import { useEffect } from "react";
import { seo } from "@/config/site";

/**
 * Loads Google Analytics (gtag.js) only when `REACT_APP_GOOGLE_ANALYTICS_ID`
 * (or seo.googleAnalyticsId) is configured. Otherwise renders nothing.
 */
export default function Analytics() {
  useEffect(() => {
    const id = seo.googleAnalyticsId;
    if (!id) return;
    if (document.getElementById("ga4-loader")) return;

    const script = document.createElement("script");
    script.async = true;
    script.id = "ga4-loader";
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(script);

    const inline = document.createElement("script");
    inline.id = "ga4-inline";
    inline.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${id}');`;
    document.head.appendChild(inline);
  }, []);
  return null;
}
